var App = App || {};

App.WidgetRates = (function ($) {
    'use strict';

    function Init(selector) {

        if (selector.length) {

            const carousel = selector.find(".splide");
            const slides = carousel.find(".splide__slide");

            if (slides.length > 3) {

                const options = {
                    type: 'slide',
                    speed: 500,
                    arrows: true,
                    pagination: false,
                    perMove: 3,
                    perPage: 3,
                    padding: '1rem',
                    gap: '2.5rem',
                    mediaQuery: 'max',
                    breakpoints: {
                        991: {
                            perMove: 1,
                            perPage: 1,
                            padding: '15%',
                            gap: '2rem',
                        }
                    }
                };

                const splide = new Splide(carousel[0], options);
                splide.mount({});
            }
        }
    }

    return {
        Init: Init
    };

})(jQuery);